export enum ESuggestedPortfolioBuilderSteps {
  GOAL_DATE,
  INITIAL_INVESTMENT,
  PORTFOLIO_SELECT,
  DETAILS,
  CONCLUSION,
  ERROR
}

export enum EStatusType {
  DEFAULT = 'default',
  ERROR = 'error'
}
